@use '@bitgmbh/ebiz-patterns-core/src/components/select-options';

:host {
  @extend .baywa-select-options;
  --baywa-select-options-open-height: 308px;

  &.open {
    grid-template-rows: 1fr;
  }
}
